/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DtoJournalLinkageStatusResponse,
  PresenterDeletableAccountItem,
  PresenterDeletableAccountSubItem,
  PresenterDeletableDept,
  PresenterDeletableExcise,
  PresenterDisableableAccountItem,
  PresenterDisableableAccountSubItem,
  PresenterError,
  PresenterJournalLinkageResultResponse,
  PresenterOneAccPlusDeptResponse,
  PresenterOneExportJournalHistoryResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class AccountingPlus<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get department list from accounting plus
   *
   * @tags accounting_plus
   * @name DepartmentsList
   * @summary Get the department list from accounting plus
   * @request GET:/acc_plus/departments
   */
  departmentsList = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneAccPlusDeptResponse[];
      },
      any
    >({
      path: `/acc_plus/departments`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description get journal list with status of a linkage history
   *
   * @tags accounting_plus
   * @name JournalLinkageHistoryDetailList
   * @summary get journal list of a linkage history
   * @request GET:/acc_plus/journal_linkage_history_detail
   */
  journalLinkageHistoryDetailList = (
    query: {
      /** ID of a linkage history */
      linkage_history_id: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterJournalLinkageResultResponse;
      },
      PresenterError
    >({
      path: `/acc_plus/journal_linkage_history_detail`,
      method: "GET",
      query: query,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description check accounting plus permission, setting and last submit
   *
   * @tags accounting_plus
   * @name JournalLinkageStatusList
   * @summary check journal linkage status
   * @request GET:/acc_plus/journal_linkage_status
   */
  journalLinkageStatusList = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: DtoJournalLinkageStatusResponse;
      },
      PresenterError
    >({
      path: `/acc_plus/journal_linkage_status`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description send journals to AccPlus
   *
   * @tags accounting_plus
   * @name JournalLinkageSubmitCreate
   * @summary send journals to AccPlus
   * @request POST:/acc_plus/journal_linkage_submit
   * @secure
   */
  journalLinkageSubmitCreate = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneExportJournalHistoryResponse;
      },
      any
    >({
      path: `/acc_plus/journal_linkage_submit`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description check department is deletable or not
   *
   * @tags accounting_plus
   * @name TenantsDeptsDeletableList
   * @summary check department is deletable or not
   * @request GET:/ca_mid/tenants/{office_id}/depts/deletable
   * @secure
   */
  tenantsDeptsDeletableList = (
    officeId: number,
    query: {
      /** list of department id from accountint plus */
      dept_ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterDeletableDept[], any>({
      path: `/ca_mid/tenants/${officeId}/depts/deletable`,
      method: "GET",
      query: query,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description check excises is deletable or not
   *
   * @tags accounting_plus
   * @name TenantsExcisesDeletableList
   * @summary check excises is deletable or not
   * @request GET:/ca_mid/tenants/{office_id}/excises/deletable
   * @secure
   */
  tenantsExcisesDeletableList = (
    officeId: number,
    query: {
      /** list of excise id */
      excise_ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterDeletableExcise[], any>({
      path: `/ca_mid/tenants/${officeId}/excises/deletable`,
      method: "GET",
      query: query,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description check items is deletable or not
   *
   * @tags accounting_plus
   * @name TenantsItemsDeletableList
   * @summary check items is deletable or not
   * @request GET:/ca_mid/tenants/{office_id}/items/deletable
   * @secure
   */
  tenantsItemsDeletableList = (
    officeId: number,
    query: {
      /** list of item id */
      item_ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterDeletableAccountItem[], any>({
      path: `/ca_mid/tenants/${officeId}/items/deletable`,
      method: "GET",
      query: query,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description check items can disable or not
   *
   * @tags accounting_plus
   * @name TenantsItemsDisableableList
   * @summary check items can disable or not
   * @request GET:/ca_mid/tenants/{office_id}/items/disableable
   * @secure
   */
  tenantsItemsDisableableList = (
    officeId: number,
    query: {
      /** list of item id */
      item_ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterDisableableAccountItem[], any>({
      path: `/ca_mid/tenants/${officeId}/items/disableable`,
      method: "GET",
      query: query,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description check sub_items is deletable or not
   *
   * @tags accounting_plus
   * @name TenantsSubItemsDeletableList
   * @summary check sub_items is deletable or not
   * @request GET:/ca_mid/tenants/{office_id}/sub_items/deletable
   * @secure
   */
  tenantsSubItemsDeletableList = (
    officeId: number,
    query: {
      /** list of sub item id */
      sub_item_ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterDeletableAccountSubItem[], any>({
      path: `/ca_mid/tenants/${officeId}/sub_items/deletable`,
      method: "GET",
      query: query,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description check items can disable or not
   *
   * @tags accounting_plus
   * @name TenantsSubItemsDisableableList
   * @summary check items can disable or not
   * @request GET:/ca_mid/tenants/{office_id}/sub_items/disableable
   * @secure
   */
  tenantsSubItemsDisableableList = (
    officeId: number,
    query: {
      /** list of sub item id */
      sub_item_ids: number[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterDisableableAccountSubItem[], any>({
      path: `/ca_mid/tenants/${officeId}/sub_items/disableable`,
      method: "GET",
      query: query,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
